/* eslint-disable no-undef */
import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { isAuthenticated, getLoginUrl } from '../utility/common';
import App from '../App';

const MainContainer = ({ component: Component, ...rest }) => {
  // eslint-disable-next-line spaced-comment
  const isIE = /*@cc_on!@*/false || !!document.documentMode;
  if (isIE) {
    return <Redirect to="incompatible" />;
  }

  if (!isAuthenticated()) {
    window.location.href = getLoginUrl();
    return null;
  }
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <Route {...rest} render={(props) => <App component={<Component {...props} />} />} />;
};

/** Required function and props with the proptypes */
MainContainer.propTypes = {
  component: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
};

export default MainContainer;
